import { ArrowRightIcon } from "@heroicons/react/solid";
import React from "react";

export default function Navbar() {
  return (
    <header className="bg-gray-800 md:sticky top-0 z-10">
      <div className="container mx-auto flex flex-wrap p-5 flex-col md:flex-row items-center">
        <a className="title-font font-medium text-white mb-4 md:mb-0">
          <a href="#about" className="ml-3 text-xl">
            Sanchitha Dinesh
          </a>
        </a>
        <nav className="md:mr-auto md:ml-4 md:py-1 md:pl-4 md:border-l md:border-gray-700	flex flex-wrap items-center text-base justify-center">
          <a href="#projects" className="mr-5 hover:text-white">
            Projects
          </a>
          <a href="#work" className="mr-5 hover:text-white">
            Work Experience
          </a>
          <a href="#supernova" className="mr-5 hover:text-white">
            Supernova Hackathon
          </a>
          <a href="#awards" className="mr-5 hover:text-white">
            Awards
          </a>
          <a href="#supernova" className="mr-5 hover:text-white">
            Other Activities
          </a>
          <a href="#skills" className="mr-5 hover:text-white">
            Skills
          </a>
          <a href="#hobbies" className="mr-5 hover:text-white">
            Hobbies
          </a>
        </nav>
      </div>
    </header>
  );
}